import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useRandomRotation } from '../../hooks/useRandomQuadrilateral';
import SkewedButton from '../common/SkewedButton';

const Header: React.FC = () => {
  const { currentUser, logout } = useAuth();
  const location = useLocation();
  const borderRotation = useRandomRotation(0.5);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error('Failed to log out', err);
    }
  };

  // Helper function to set active link styles
  const isActive = (path: string) => {
    return location.pathname === path ? 'font-black border-b-3' : 'font-semibold';
  };

  return (
    <header className="bg-white relative">
      {/* Angled bottom border */}
      <div
        className="absolute bottom-0 left-0 right-0 h-px bg-gray-200 origin-center"
        style={{ transform: borderRotation }}
      />
      <div className="container mx-auto px-4 py-5">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-3xl font-black text-black tracking-tight">MURALIST</Link>

          <nav className="flex items-center space-x-8">
            <Link to="/" className={`text-black text-lg px-2 py-1 ${isActive('/')}`}>Home</Link>
            <Link to="/about" className={`text-black text-lg px-2 py-1 ${isActive('/about')}`}>About</Link>
            <Link to="/gallery" className={`text-black text-lg px-2 py-1 ${isActive('/gallery')}`}>Gallery</Link>
            <Link to="/ar" className={`text-black text-lg px-2 py-1 ${isActive('/ar')}`}>AR</Link>
            <Link to="/contact" className={`text-black text-lg px-2 py-1 ${isActive('/contact')}`}>Contact</Link>

            {currentUser ? (
              <div className="flex items-center space-x-4">
                <SkewedButton to="/admin" variant="primary">Admin</SkewedButton>
                <SkewedButton onClick={handleLogout} variant="secondary">Logout</SkewedButton>
              </div>
            ) : (
              <SkewedButton to="/login" variant="primary">Login</SkewedButton>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;